const LOCAL_STORAGE_COMPARE_KEY = 'shopify-compare';
const LOCAL_COMPARE_STORAGE_DELIMITER = ',';
const BUTTON_COMPARE_ACTIVE_CLASS = 'active';
const GRID_COMPARE_LOADED_CLASS = 'loaded';

const compareSelectors = {
  button: '[button-compare]',
  grid: '[grid-compare]',
  productCard: '.product-card-compare',
};

/* =========================
   INIT
========================= */
document.addEventListener('DOMContentLoaded', () => {
  initButtonsCompare(); // ✅ ALWAYS initialize
  initGridCompare();
  updateCompareCount();
});

/* =========================
   EVENTS
========================= */
document.addEventListener('shopify-compare:updated', (event) => {
  console.log('[Shopify Compare] Updated ✅', event.detail.compare);
  initGridCompare();
  initButtonsCompare();
  updateCompareCount();
});

/* Cross-tab / real-time sync */
window.addEventListener('storage', (e) => {
  if (e.key === LOCAL_STORAGE_COMPARE_KEY) {
    updateCompareCount();
    initGridCompare();
    initButtonsCompare();
  }
});

/* =========================
   FETCH PRODUCT CARD
========================= */
const fetchCompareProductCardHTML = async (handle) => {
  try {
    const res = await fetch(`/products/${handle}?view=card`);
    const text = await res.text();

    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(text, 'text/html');

    const productCard = htmlDocument.querySelector(compareSelectors.productCard);
    return productCard ? productCard.outerHTML : '';
  } catch (err) {
    console.error(`[Compare] Failed for ${handle}`, err);
    return '';
  }
};

/* =========================
   GRID SETUP
========================= */
const setupGridCompare = async (grid) => {
  const compare = getCompare();

  if (!compare.length) {
    grid.innerHTML = `<p>No products added to compare.</p>`;
    return;
  }

  const requests = compare.map(fetchCompareProductCardHTML);
  const responses = await Promise.all(requests);

  grid.innerHTML = responses.join('');
  grid.classList.add(GRID_COMPARE_LOADED_CLASS);

  initButtonsCompare();
};

const initGridCompare = () => {
  const grid = document.querySelector(compareSelectors.grid);
  if (grid) setupGridCompare(grid);
};

/* =========================
   BUTTON SETUP (FIXED)
========================= */
const setupCompareButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle;
    if (!productHandle) return;

    // ✅ Prevent duplicate listeners
    const newButton = button.cloneNode(true);
    button.parentNode.replaceChild(newButton, button);

    // ✅ Set active state
    if (compareContains(productHandle)) {
      newButton.classList.add(BUTTON_COMPARE_ACTIVE_CLASS);
    } else {
      newButton.classList.remove(BUTTON_COMPARE_ACTIVE_CLASS);
    }

    // ✅ Click event
    newButton.addEventListener('click', () => {
      updateCompare(productHandle);
      newButton.classList.toggle(BUTTON_COMPARE_ACTIVE_CLASS);
    });
  });
};

const initButtonsCompare = () => {
  const buttons = document.querySelectorAll(compareSelectors.button);
  if (buttons.length) setupCompareButtons(buttons);
};

/* =========================
   STORAGE FUNCTIONS
========================= */
const getCompare = () => {
  const compare = localStorage.getItem(LOCAL_STORAGE_COMPARE_KEY);

  if (!compare) return [];

  // ✅ Remove empty values
  return compare
    .split(LOCAL_COMPARE_STORAGE_DELIMITER)
    .filter(item => item && item.trim() !== '');
};

const setCompare = (array) => {
  if (array.length) {
    localStorage.setItem(
      LOCAL_STORAGE_COMPARE_KEY,
      array.join(LOCAL_COMPARE_STORAGE_DELIMITER)
    );
  } else {
    localStorage.removeItem(LOCAL_STORAGE_COMPARE_KEY);
  }

  // ✅ Force UI refresh everywhere
  updateCompareCount();
  initButtonsCompare();
  initGridCompare();

  document.dispatchEvent(
    new CustomEvent('shopify-compare:updated', {
      detail: { compare: array },
    })
  );

  return array;
};

const updateCompare = (handle) => {
  const compare = getCompare();
  const index = compare.indexOf(handle);

  if (index === -1) compare.push(handle);
  else compare.splice(index, 1);

  return setCompare(compare);
};

const compareContains = (handle) => {
  return getCompare().includes(handle);
};

const resetCompare = () => {
  return setCompare([]);
};

/* =========================
   COUNT UPDATE (NO JQUERY)
========================= */
const updateCompareCount = () => {
  const compare = getCompare();

  document.querySelectorAll('[data-js-compare-count]').forEach((el) => {
    el.textContent = compare.length;
    el.setAttribute('data-js-compare-count', compare.length);
  });

  const compInfo = document.querySelector('.comp-info');
  if (compInfo) {
    compInfo.style.display = compare.length === 0 ? 'block' : 'none';
  }
};